import React from 'react';

import {Flags} from '../flags/Flags';
import {Help} from '../help/Help';
import {Inbox} from '../inbox/Inbox';
import {Login} from '../login/Login';
import {Scratchpad} from '../scratchpad/Scratchpad';
import {Traveler} from '../traveler/Traveler';
import GlobalizationSelectorConnector from '../../connectors/GlobalizationSelectorConnector';
import {TrackingContext} from '@homeaway/react-event-tracking';

import './Nav.less';
import {SupportNumberScreenreader} from '../support-number-screenreader/SupportNumberScreenreader';

export class Nav extends React.Component {
    static contextType = TrackingContext;

    constructor(props, context) {
        super(props, context);
    }

    get feedbackComponent() {
        if (this.props.isMobile || !this.props.feedbackComponent) {
            return null;
        }

        return (
            <div
                className="site-header-feedback">
                {this.props.feedbackComponent}
            </div>
        );
    }

    handleClickScratchPad = () => {
        const fields = {
            actionlocation: 'header.tripboards'
        };
        this.context.trigger('header.link.click', fields);
    }

    handleClickInbox = () => {
        const fields = {
            actionlocation: 'header.inbox'
        };
        this.context.trigger('header.link.click', fields);
    }

    renderGlobalSelector() {
        if (!this.props.renderCountryLanguageSelector && !this.props.renderCurrencySelector) {
            return null;
        }

        return (
            <GlobalizationSelectorConnector
                className="site-header-nav__dropdown"
                {...this.props.globalizationSelector}
                countryCode={this.props.countryCode}
                currencyCode={this.props.currencyCode}
                languageCode={this.props.languageCode}
                onGlobalSelectorChange={this.props.onGlobalSelectorChange}
                renderCountryLanguageSelector={this.props.renderCountryLanguageSelector}
                renderCurrencySelector={this.props.renderCurrencySelector}
            />
        );
    }

    renderAccessibility() {
        if (!this.props.accessibility) {
            return null;
        }
        return (
            <SupportNumberScreenreader {...this.props.accessibility} />
        );
    }

    renderExtraNav() {
        if (!this.props.extraNav) {
            return null;
        }

        if (!this.props.extraNav.items) {
            return null;
        }

        return this.props.extraNav.items.map((item, index) => (
            <a
                className={`site-header-nav__link ${item.cssClass}`}
                data-bypass="true"
                href={item.link}
                key={index}
            >{item.text}</a>
        ));
    }

    renderFlags() {
        if (!this.props.flags) {
            return null;
        }

        return (
            <Flags {...this.props.flags} />
        );
    }

    renderHelp() {
        if (!this.props.help) {
            return null;
        }

        return (
            <Help {...this.props.help} />
        );
    }

    renderInbox() {
        if (!this.props.traveler || !this.props.inbox) {
            return null;
        }

        return (
            <a className="site-header-nav__link" data-bypass="true" href={this.props.inbox.link} onClick={this.handleClickInbox}>
                <Inbox {...this.props.inbox} />
            </a>
        );
    }

    renderInternalTools() {
        if (!this.props.internalTools) {
            return null;
        }

        return this.props.internalTools;
    }

    renderLogin() {
        if (!this.props.login) {
            return null;
        }

        return (
            <Login {...this.props.login} />
        );
    }

    renderScratchpad() {
        if (!this.props.scratchpad) {
            return null;
        }

        return (
            <a
                className="site-header-nav__link"
                data-bypass="true"
                href={this.props.scratchpad.link}
                onClick={this.handleClickScratchPad}
            >
                <Scratchpad {...{...this.props.scratchpad, tripboard: this.props.tripboard}}/>
            </a>
        );
    }

    renderTraveler() {
        if (!this.props.traveler) {
            return null;
        }

        return (
            <Traveler {...this.props.traveler} />
        );
    }

    render() {
        return (
            <div className="site-header-nav" role="navigation">
                {this.renderAccessibility()}
                {this.renderScratchpad()}
                {this.renderInbox()}
                {this.renderLogin()}
                {this.renderTraveler()}
                {this.renderHelp()}
                {this.renderExtraNav()}
                {this.renderInternalTools()}
                {this.feedbackComponent}
                {this.renderFlags()}
                {this.renderGlobalSelector()}
            </div>
        );
    }
}
